import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Button, TextField, Paper, Typography } from "@material-ui/core";
import { useNavigate, useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { typeAPI } from "../services/TypeAPI";
import * as Yup from "yup";
import Swal from 'sweetalert2'
// import './edittype.css'

const EditTpye = ({ isMobile, closeNav }) => {
    const [data, setData] = useState(null)
    const navigate = useNavigate();
    const { _id } = useParams()
    const { isLoading } = useSelector(state => state.user)
    const { DataType, DataTypeAdmin } = useSelector(state => state.type)


    useEffect(() => {
        typeAPI.getTypeByID(_id)
            .then((res) => {
                if (res.status == 200) {
                    setData(res.message)
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "red",
                        text: res.message,
                        timer: 5000
                    }).then(() => {
                        navigate('/manage-type')
                    })
                }
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    confirmButtonColor: "red",
                    text: error.message,
                    timer: 5000
                }).then(() => {
                    navigate('/manage-type')
                })
            })
    }, [_id])


    const FormSchema = Yup.object().shape({
        name: Yup.string()
            .min(3, "ป้อนอักษรอย่างน้อย 5 ตัว")
            .max(255, "ป้อนอักษรมากสุด 255 ตัว")
            .trim()
            .required("ป้อนชื่อเอกสาร"),
    }
    );

    const useStyles = makeStyles(theme => ({
        leftIcon: {
            marginRight: theme.spacing(1)
        },
        root: {
            padding: theme.spacing(4, 3)
        },
        container: {
            display: "block",
            flexWrap: "wrap"
        },
        textField: {
            marginLeft: theme.spacing(2),
            marginRight: theme.spacing(2),
            marginTop: theme.spacing(1),
            width: 400
        },
        button: {
            marginTop: theme.spacing(2)
        },
        mt_1: {
            margin: theme.spacing(3)
        }
    }));

    const classes = useStyles();

    return (
        !isLoading && <Formik
            enableReinitialize
            validationSchema={FormSchema}
            initialValues={{ name: data ? data.name : '' }}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    let arraycheck = []
                    if (Array.isArray(DataTypeAdmin) && DataTypeAdmin.length >= 1) {
                        arraycheck = DataTypeAdmin
                    }
                    else if (Array.isArray(DataType) && DataType.length >= 1) {
                        arraycheck = DataType
                    }
                    let removehimseft = arraycheck.filter((res) => res._id != _id)
                    let findType = removehimseft.find((res) => res.name == values.name)
                    if (findType) throw { message: `ชื่อ Type ${values.name}ซ้ำ` }
                    setSubmitting(true)
                    Swal.fire({
                        title: `ยืนยันที่จะแก้ไข ${data.name} เป็น ${values.name} ?`,
                        confirmButtonColor: "#6ab23a",
                        showCancelButton: true,
                        confirmButtonText: "OK!",
                    }).then(result => {
                        if (result.isConfirmed) {
                            typeAPI.editType({ name: values.name, _id })
                                .then((res) => {
                                    if (res.status == 200) {
                                        Swal.fire({
                                            icon: 'success',
                                            confirmButtonColor: "#6ab23a",
                                            text: `เปลี่ยน ${data.name} เป็น ${values.name} เรียบร้อยแล้ว`,
                                            timer: 5000
                                        }).then(() => {
                                            navigate('/manage-type')
                                        })
                                    }
                                    else {
                                        Swal.fire({
                                            icon: 'error',
                                            confirmButtonColor: "#6ab23a",
                                            text: `${res.message}`,
                                            timer: 5000
                                        })
                                    }
                                    setSubmitting(false)
                                })
                                .catch((error) => {
                                    Swal.fire({
                                        icon: 'error',
                                        confirmButtonColor: "#6ab23a",
                                        text: `${error.message}`,
                                        timer: 5000
                                    })
                                    setSubmitting(false)
                                })
                        }
                    })
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        confirmButtonColor: "red",
                        text: error.message,
                        timer: 5000
                    })
                }
            }}
        >
            {({
                values,
                handleChange,
                isSubmitting,
                touched,
                errors,
            }) => (
                <Form className='container h-100vh' style={{ display:closeNav ? 'block':isMobile?'none':'block', marginTop: !isMobile ? 0 : '70px', justifyContent: 'flex-end', padding: !isMobile ? 'none':'0' }}>
                    <Paper className={`${classes.root} col-root`} style={{ boxShadow: 'none', padding: '3%'}}>
                        <h3 style={{ fontSize: '38px'}}>แก้ไขประเภทเอกสาร</h3>
                        <TextField
                            className={`${classes.textField} `}
                            helperText="ชื่อประเภทเอกสาร สำหรับแสดง"
                            name={"name"}
                            value={values.name}
                            onChange={handleChange}
                            style={{ marginTop: '4%'}}
                        />
                        <Typography 
                            component="div"
                            style={{ marginTop: '' }}
                        >
                            {errors.name && touched.name ? (
                                <div style={{ color: "#FF3333" }}>{errors.name}</div>
                            ) : null}

                        </Typography>
                        <Button
                            type="submit"
                            disabled={isSubmitting}
                            variant="contained"
                            style={{
                                textTransform: 'none', backgroundColor: "#6ab23a", color: 'white', cursor: 'pointer', marginTop: '4%'
                            }}
                            className={classes.button}
                        >
                            บันทึก
                        </Button>
                    </Paper>
                </Form>)}
        </Formik>
    )
}
export default EditTpye